import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'


// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
    el: ".banner .swiper-pagination",
    clickable: true,
  },
}); 

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".banner").offset().top + $("header").height()  && istrue) {
    $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
}
if ( window.innerWidth < 1550) {
  $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
}


$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".banner").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})


var product = new Swiper(".section2 .mySwiper", {
    slidesPerView: 3.69,
    spaceBetween: '1.82%',
    navigation: {
        nextEl: ".section2  .swiper-button-next",
        prevEl: ".section2  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3.69,
        spaceBetween: '1.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});

$(".service-list ul li").eq(0).addClass('active');
$(".service-pic a").eq(0).addClass('active');
$(".service-list ul li").hover(function() {
  let index = $(this).index();
  $(this).addClass('active').siblings().removeClass('active');
  $(".service-pic a").eq(index).addClass('active').siblings().removeClass('active');
})